import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

export const getFindActiveBannersKey = (limit: number): UseDataQuery['queryKey'] => [
  'banners',
  undefined,
  { active: true, limit },
];
